import React, { useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';

import { useSelector } from 'react-redux';
import { InformationCircleIcon } from '@heroicons/react/outline';
import { toast as toastSelector } from '../../redux/selectors';

const stylesToastTypes = {
    warning: {
        className: 'bg-yellow-400 text-white',
        iconTheme: {
            primary: '#fff',
            secondary: '#FBBF24',
        },
        icon: <InformationCircleIcon className="h-6 w-6" />,
    },
    success: {
        className: 'bg-green-400 text-white',
        iconTheme: {
            primary: '#fff',
            secondary: '#FBBF24',
        },
    },
    error: {
        className: 'bg-red-500 text-white',
        iconTheme: {
            primary: '#fff',
            secondary: '#DC2626',
        },
    },
};

export default function Toast() {
    const toastState = useSelector(toastSelector);

    const handleEvent = (type) => {
        switch (type) {
            case 'success':
                toast.success(toastState.message, {
                    ...stylesToastTypes.success,
                    duration: toastState.duration,
                });
                break;
            case 'warning':
                toast.error(toastState.message, {
                    ...stylesToastTypes.warning,
                    duration: toastState.duration,
                });
                break;
            case 'error':
                toast(toastState.message, {
                    ...stylesToastTypes.error,
                    duration: toastState.duration,
                });
                break;
            default:
                toast(toastState.message);
                break;
        }
    };

    useEffect(() => {
        if (toastState.show) {
            handleEvent(toastState.type);
        } else {
            toast.remove();
        }
    }, [toastState]);

    return <Toaster position="top-right" reverseOrder={false} />;
}
